<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsImport-storeData',
  components: { PageTable },
}
</script>
